import { TodayStatus, TodayStatusFromJSON } from '@/api'
import * as runtime from '../runtime'

export class TodayStatusApi extends runtime.BaseAPI {
  /**
   * 処理場所を変更する
   * 処理場所変更
   */
  async getTodayStatus(): Promise<TodayStatus> {
    const response = await this.requestGet('/today-status')

    return new runtime.JSONApiResponse(response, jsonValue =>
      TodayStatusFromJSON(jsonValue)
    ).value()
  }
}
